<template>
  <div class="hm-home">
    <el-card>
      <div class="panel flex item-center flex-between">
        <div class="button-wrapper">
          <el-button size="small" type="primary" @click="toAdd"
            >增加发放优惠券</el-button
          >
        </div>
        <div class="form-wrapper flex">
          <!-- <el-select
            class="mr10"
            size="small"
            clearable
            placeholder="选择排序字段"
            v-model="sortColumn"
          >
            <el-option
              v-for="(item, i) in sortColumnList"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            class="mr10"
            size="small"
            clearable
            placeholder="选择排序方式"
            v-model="sortType"
          >
            <el-option
              v-for="(item, i) in sortTypeList"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select> -->
          <el-select
            class="mr10"
            size="small"
            clearable
            placeholder="选择发放类型"
            v-model="sendWayType"
          >
            <el-option
              v-for="(item, i) in sendWayTypeOption"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            class="mr10"
            size="small"
            clearable
            filterable
            placeholder="选择发放限制"
            v-model="event"
            :disabled="sendWayType !== 0 && sendWayType !== 4"
          >
            <el-option
              v-show="sendWayType === item.sendWayType"
              v-for="(item, i) in eventOption"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            class="mr10"
            size="small"
            clearable
            placeholder="选择发放对象"
            v-model="sendTarget"
          >
            <el-option
              v-for="(item, i) in sendTargetOption"
              :key="i"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            size="small"
            clearable
            placeholder="选择会员类型"
            v-model="isPlus"
            style="width: 150px"
            class="mr10"
          >
            <el-option
              v-for="item in members"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            class="mr10"
            size="small"
            clearable
            placeholder="输入发放名称/副标题查询"
            v-model.trim="keywords"
            style="width: 150px"
          ></el-input>
          <el-button
            size="small"
            @click="reset"
            class="mr10 hmicon icon-zhongzhi reset"
          ></el-button>
          <el-button class="ml0" size="small" type="primary" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table">
        <div class="flex table-panel">
          <span
            class="btn"
            :class="{ active: v.index === activeTab }"
            @click="switchTab(v.index)"
            v-for="(v, i) in btnList"
            :key="i"
            >{{ v.name }}</span
          >
        </div>
        <div class="send-table">
          <el-table
            border
            :data="sendCouponsList"
            style="width: 100%"
            @sort-change="sortChange"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="(index) => index + (currentPage - 1) * pageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="发放名称"
            >
              <template slot-scope="scope">
                <span v-show="scope.row.edit_name">
                  <span
                    v-if="scope.row.status !== 0"
                    class="coupon-name pointer"
                    @click="toDetail(scope.row)"
                    >{{ scope.row.name }}</span
                  >
                  <span v-else>{{ scope.row.name }}</span>
                  <span
                    @click="changeEndName(scope.$index, scope.row)"
                    class="pointer hmicon icon-shuru blue ml10"
                  ></span>
                </span>
                <el-input
                  :ref="'nameinput' + scope.$index"
                  @blur="endNameblur(scope.$index, scope.row)"
                  @keyup.enter.native="$event.target.blur"
                  clearable
                  v-show="!scope.row.edit_name"
                  size="mini"
                  style="width: 100%"
                  v-model="scope.row.name"
                  placeholder="请输入"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="remark"
              label="副标题"
            >
              <template slot-scope="scope">
                <div
                  @click="changeEnddate(scope.$index, scope.row)"
                  style="height: 30px"
                >
                  <span v-show="scope.row.edit_enddate"
                    >{{ scope.row.remark }}
                    <span class="hmicon icon-shuru blue"></span>
                  </span>
                  <el-input
                    :ref="'enddateinput' + scope.$index"
                    @blur="enddateblur(scope.$index, scope.row)"
                    @keyup.enter.native="$event.target.blur"
                    clearable
                    v-show="!scope.row.edit_enddate"
                    size="mini"
                    style="width: 100%"
                    v-model="scope.row.remark"
                    placeholder="请输入内容"
                  ></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="sendWayTypeFormat"
              label="发放类型"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="eventFormat"
              label="发放限制"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="sendStartDate"
              label="发放时间"
              width="250"
              sortable
            >
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="text"
                  @click="getSendTime(scope.row.couponSendId)"
                  v-if="
                    scope.row.sendWayType !== 1 &&
                    scope.row.sendTimeStrategyType !== 4 &&
                    scope.row.event !== 'luckyDraw'
                  "
                  >{{ scope.row.sendDate }}</el-button
                >
                <span
                  v-else-if="
                    scope.row.sendWayType !== 1 &&
                    scope.row.sendTimeStrategyType === 4
                  "
                  style="font-size: 12px"
                >
                  {{
                    `${scope.row.sendStartDate} ${
                      scope.row.sendStartTime.split(",")[0]
                    }`
                  }}
                  <br />
                  至
                  <span
                    @dblclick="hidden(scope.row, scope.$index)"
                    v-show="scope.row.isShow"
                    >{{
                      `${scope.row.sendEndDate} ${
                        scope.row.sendEndTime.split(",")[0]
                      }`
                    }}</span
                  >
                  <el-date-picker
                    :ref="'enddateDate' + scope.$index"
                    v-show="!scope.row.isShow"
                    @blur="editTime(scope.row, scope.$index)"
                    style="width: 200px"
                    size="mini"
                    v-model="scope.row.sendEndDate"
                    type="datetime"
                    placeholder="选择日期时间"
                  >
                  </el-date-picker>
                </span>
                <span
                  v-else-if="scope.row.sendWayType === 1"
                  style="font-size: 12px"
                  >{{ scope.row.createTimeFormat }}</span
                >
                <span
                  v-else-if="scope.row.event === 'luckyDraw'"
                  style="font-size: 12px"
                  >{{ scope.row.sendDate }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="createTime"
              label="创建时间"
              sortable
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="sendNumFormat"
              label="发放数量"
            ></el-table-column>
            <!-- <el-table-column  header-align="center" align="center"  prop="name" label="领取数量">
            </el-table-column>
            <el-table-column  header-align="center" align="center"  prop="name" label="使用数量">
            </el-table-column>-->
            <el-table-column
              header-align="center"
              align="center"
              prop="createBy"
              label="创建人"
            ></el-table-column>
            <el-table-column header-align="center" align="center" label="状态">
              <template slot-scope="scope">
                {{ activeTab === 2 ? "已作废" : scope.row.statusFormat }}
              </template>
            </el-table-column>
            <!-- <el-table-column header-align="center" align="center" prop="typeFormat" label="发放对象">
            </el-table-column>-->
            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              width="200"
            >
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="text"
                  @click="copy(scope.row.couponSendId)"
                  >查看</el-button
                >
                <!-- 
                  v-show="
                    scope.row.status !== 1 &&
                      scope.row.status !== 3 &&
                      scope.row.status !== 4
                  "-->
                <el-button
                  v-show="scope.row.status !== 3 && scope.row.status !== 4"
                  size="small"
                  type="text"
                  @click="edit(scope.row.couponSendId)"
                  >编辑</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  @click="publish(scope.row.couponSendId)"
                  v-show="
                    scope.row.status !== 1 &&
                    scope.row.status !== 3 &&
                    scope.row.status !== 4
                  "
                  >发布</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  @click="productQrcode(scope.row.couponSendId)"
                  v-show="
                    scope.row.isPlus === 1 &&
                    (scope.row.sendWayType === 2 ||
                      scope.row.sendWayType === 5) &&
                    (scope.row.event === 'fetch' ||
                      scope.row.event === 'self') &&
                    scope.row.isActivity === 1 &&
                    scope.row.status !== 3 &&
                    scope.row.status !== 0
                  "
                  >生成二维码</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  @click="showCdkey(scope.row.id)"
                  v-show="
                    scope.row.event === 'exchange' &&
                    scope.row.status !== 3 &&
                    scope.row.status !== 0
                  "
                  >查看兑换码</el-button
                >
                <el-button
                  size="small"
                  type="text"
                  @click="invalidate(scope.row)"
                  v-show="scope.row.status !== 3 && !scope.row.isExpired"
                  >作废</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="text-center">
        <el-pagination
          background
          layout="total,sizes,  prev, pager, next, jumper"
          :total="sendCouponsListTotal"
          @current-change="paging"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </el-card>
    <el-dialog
      title="请用微信扫一扫"
      :visible.sync="dialogVisible"
      :modal="false"
      width="250px"
    >
      <div class="qrcode-wrapper">
        <img :src="activityCode" alt="二维码" />
      </div>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="timeDialogVisible" width="30%">
      <el-table border :data="sendValidTimes">
        <el-table-column
          header-align="center"
          align="center"
          prop="sendStartTime"
          label="起始时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sendEndTime"
          label="结束时间"
        ></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="兑换码列表" :visible.sync="showCdkModal">
      <div class="btn-wrapper">
        <el-button size="small" @click="output" :disabled="cdkey.length <= 0"
          >导出excel</el-button
        >
      </div>
      <el-table border :data="cdkey">
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="redeem_code"
          label="兑换码"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="statusFormat"
          label="兑换状态"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="real_name"
          label="兑换人"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "../../utils/utils";
import { getLoginUser, getUserName } from "@/utils/auth";

// import { getLoginUser } from "@/utils/auth";
import moment from "moment";
export default {
  data() {
    return {
      isShowPicker: false,
      isShow: true,
      sendEndDate: "",
      status: "1",
      showCdkModal: false,
      currentPage: 1,
      pageSize: 10,
      sendWayType: "",
      event: "",
      sendTarget: "",
      dialogVisible: false,
      timeDialogVisible: false,
      value: "",
      keywords: "",
      url: "",
      activityCode: "",
      remark: "",
      isPlus: "",
      sendValidTimes: [],
      members: [
        { name: "PLUS会员", value: 0 },
        { name: "全部会员", value: 1 },
      ],
      sendWayTypeOption: [
        {
          value: 0,
          label: "自动发放",
        },
        {
          value: 1,
          label: "手动发放",
        },
        {
          value: 2,
          label: "自助领券",
        },
        {
          value: 3,
          label: "兑换码领取",
        },
        {
          value: 4,
          label: "活动发放",
        },
      ],
      eventOption: [
        {
          value: "registe",
          label: "开卡绑定",
          sendWayType: 0,
        },
        {
          value: "follow",
          label: "关注公众号",
          sendWayType: 0,
        },
        {
          value: "levelup",
          label: "升级plus会员",
          sendWayType: 0,
        },
        {
          value: "orderOffline",
          label: "门店交易",
          sendWayType: 0,
        },
        {
          value: "orderOnline",
          label: "线上交易",
          sendWayType: 0,
        },
        {
          value: "recharge",
          label: "充值发放",
          sendWayType: 0,
        },
        {
          value: "PasswordRedEnvelope",
          label: "口令红包",
          sendWayType: 0,
        },
        {
          value: "bigturntable",
          label: "大转盘",
          sendWayType: 0,
        },
        {
          value: "luckyDraw",
          label: "抽奖发券",
          sendWayType: 0,
        },
        {
          value: "repository",
          label: "母婴知识库",
          sendWayType: 0,
        },
        {
          value: "wyethNewCustomer",
          label: "惠氏新客",
          sendWayType: 0,
        },
        {
          value: "share",
          label: "分享发券",
          sendWayType: 0,
        },
        {
          value: "buy",
          label: "购买发券",
          sendWayType: 0,
        },
        {
          value: "charge",
          label: "核销发券",
          sendWayType: 0,
        },
        {
          value: "recommendedPurchase",
          label: "推荐购买发券",
          sendWayType: 0,
        },
        {
          value: "exchangeByPoint",
          label: "积分兑换",
          sendWayType: 4,
        },
        {
          value: "carnival",
          label: "满额领券",
          sendWayType: 4,
        },
      ],
      sendTargetOption: [
        {
          value: 0,
          label: "所有用户",
        },
        {
          value: 1,
          label: "指定用户",
        },
        {
          value: 2,
          label: "指定导购",
        },
        {
          value: 3,
          label: "指定门店",
        },
      ],
      activeTab: 1,
      btnList: [
        { name: "发放中", index: 1 },
        { name: "待发布", index: 0 },
        { name: "已过期", index: 5 },
        { name: "已作废", index: 3 },
        { name: "全部", index: 4 },
      ],
      editwxName: "",
      editName: "",
      editwxDate: "",
      sortColumn: "",
      sortType: "",
      sortColumnList: [
        {
          value: "createTime",
          label: "创建时间",
        },
        {
          value: "sendStartDate",
          label: "发放时间",
        },
      ],
      sortTypeList: [
        {
          value: "desc",
          label: "倒序",
        },
        {
          value: "asc",
          label: "正序",
        },
      ],
    };
  },
  created() {
    const conditions = getCookie({ key: "sendConditions", type: "session" });
    let status;
    if (conditions) {
      for (let key in conditions) {
        if (this.hasOwnProperty(key)) {
          this[key] = conditions[key];
        }
      }
      this.activeTab = conditions.status === "" ? 4 : conditions.status;
      status = conditions.status;
      this.setConditions(1);
      this.$store.dispatch("querySendCoupons", {
        status: conditions.status,
        sendWayType: this.sendWayType,
        type: this.sendTarget,
        event: this.event,
        keywords: this.keywords,
        pageSize: 10,
        pageNo: this.currentPage,
        isPlus: this.isPlus,
        sortColumn: this.sortColumn,
        sortType: this.sortType,
      });
    } else {
      status = this.activeTab === 4 ? "" : this.activeTab;
      this.setConditions(1);
      this.$store.dispatch("querySendCoupons", {
        status,
        sendWayType: this.sendWayType,
        type: this.sendTarget,
        event: this.event,
        keywords: this.keywords,
        pageSize: 10,
        pageNo: this.currentPage,
        isPlus: this.isPlus,
        sortColumn: this.sortColumn,
        sortType: this.sortType,
      });
    }
  },
  computed: {
    ...mapGetters([
      "cdkey",
      "sendCouponsListTotal",
      "invalidateCouponCode",
      "sendCouponsList",
      "publishCouponCode",
      "sendValidTime",
    ]),
  },
  //  mapState({
  //   cdkey: state => state.rules.cdkey,
  //   sendCouponsListTotal: state => state.rules.sendCouponsListTotal,
  //   invalidateCouponCode: state => state.rules.invalidateCouponCode,
  //   sendCouponsList: state => state.rules.sendCouponsList,
  //   publishCouponCode: state => state.rules.publishCouponCode,
  //   sendValidTime: state => state.rules.sendValidTime
  // }),
  watch: {
    invalidateCouponCode(val) {
      if (val === "0") {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.querySendCoupons(1);
        this.currentPage = 1;
      }
      this.$store.state.rules.invalidateCouponCode = "";
    },
    publishCouponCode(val) {
      if (val === 0 || val === "0") {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.querySendCoupons(1);
      }
      this.$store.state.rules.publishCouponCode = "";
    },
  },
  methods: {
    async editTime(val, index) {
      if (val.sendEndDate === "" || val.sendEndDate === this.editwxDate) {
        val.sendEndDate = this.editwxDate;
        // this.sendCouponsList = [...this.sendCouponsList];
      } else {
        const now = new Date();
        const s = moment(now).format("YYYY-MM-DD HH:mm:ss");
        console.log("now:" + s);
        const needTime = moment(val.sendEndDate).format("YYYY-MM-DD HH:mm:ss");
        console.log("needTime" + needTime);
        let params = {
          couponSendId: val.couponSendId,
          sendEndDate: needTime,
        };
        if (needTime < s) {
          this.isShow = false;
          this.isShowPicker = true;
          this.$message({
            message: "警告:不能选择小于当前的时间！请重新选择时间！",
            type: "warning",
          });
          // this.$refs.dateTime.focus();
          return false;
        } else {
          await this.$store.dispatch("send_time_edit", params);
          this.$message({
            message: "修改成功！",
            type: "success",
          });

          this.querySendCoupons(1);
        }
      }
      this.sendCouponsList[index].isShow = !this.sendCouponsList.isShow;
    },
    hidden(row, index) {
      this.editwxDate = row.sendEndDate;
      this.sendCouponsList[index].isShow = !this.sendCouponsList[index].isShow; //直接加key
      // this.sendCouponsList = [...this.sendCouponsList];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs["enddateDate" + index].focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    enddateblur(index, rowdata) {
      if (rowdata.remark === "" || rowdata.remark === this.editwxName) {
        rowdata.remark = this.editwxName;
        // this.sendCouponsList = [...this.sendCouponsList];
      } else {
        let params = {
          remark: rowdata.remark,
          couponSendId: rowdata.couponSendId,
        };
        this.$store.dispatch("editCoupon", params).then((res) => {
          if (res.code === 0) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.setConditions(1);
            this.querySendCoupons(1);
            this.currentPage = 1;
          }
        });
      }
      this.sendCouponsList[index].edit_enddate = !rowdata.edit_enddate;
    },
    endNameblur(index, rowdata) {
      if (rowdata.name === "" || rowdata.name === this.editName) {
        rowdata.name = this.editName;
        // this.sendCouponsList = [...this.sendCouponsList];
      } else {
        let params = {
          name: rowdata.name,
          couponSendId: rowdata.couponSendId,
        };
        this.$store.dispatch("editCoupon", params).then((res) => {
          if (res.code === 0) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.setConditions(1);
            this.querySendCoupons(1);
            this.currentPage = 1;
          }
        });
      }
      this.sendCouponsList[index].edit_name = !rowdata.edit_name;
    },
    changeEndName(index, rowdata) {
      this.editName = rowdata.name;

      this.sendCouponsList[index].edit_name = !rowdata.edit_name;

      // this.sendCouponsList[index].edit_enddate = !this.sendCouponsList[index]
      //   .edit_enddate; //直接加key

      // this.sendCouponsList = [...this.sendCouponsList];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs["nameinput" + index].focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    changeEnddate(index, rowdata) {
      this.editwxName = rowdata.remark;

      this.sendCouponsList[index].edit_enddate = !rowdata.edit_enddate;
      // this.sendCouponsList[index].edit_enddate = !this.sendCouponsList[index]
      //   .edit_enddate; //直接加key

      // this.sendCouponsList = [...this.sendCouponsList];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs["enddateinput" + index].focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel,
        } = require("../../utils/output/Export2Excel");
        const tHeader = ["序号", "兑换码", "兑换状态", "兑换人"];
        const filterVal = ["index", "redeem_code", "statusFormat", "real_name"];
        const list = this.cdkey;
        const data = this.formatJson(filterVal, list);
        exportJsonToExcel(tHeader, data, "优惠券兑换码");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    reset() {
      this.sendWayType = "";
      this.event = "";
      this.sendTarget = "";
      this.keywords = "";
      this.isPlus = "";
    },
    switchTab(index) {
      this.activeTab = index;
      this.currentPage = 1;
      this.status = index === 4 ? "" : index;
      this.querySendCoupons(1);
      this.setConditions(1);
    },
    toAdd() {
      this.$router.push({
        name: "AddCoupons",
        query: { type: "add" },
      });
    },
    async productQrcode(sendId) {
      const { storeCode } = getLoginUser();
      let userName = getUserName();
      let params = {
        path: `sendId=${sendId}`,
        storeCode: storeCode,
        createBy: userName,
        shareFunction: "发放优惠券",
        shareFrom: "bg",
      };
      const url = await this.$store.dispatch("shareDataSaveV2", params);
      const { result } = await this.$store.dispatch("createCouponQrcode", {
        path: `pages/coupon/center?saveUUID=${url.result}`,
      });
      this.dialogVisible = true;
      this.activityCode = result;
    },
    toDetail(v) {
      this.$router.push({
        name: "SendDetail",
        query: {
          couponSendId: v.couponSendId,
          sendName: v.name,
          isSendToGuider: v.couponSendTarget === 2 || v.type === 2,
        },
      });
      this.querySendCoupons(this.currentPage);
      this.setConditions(this.currentPage);
    },
    search() {
      this.setConditions(1);
      this.querySendCoupons(1);
      this.currentPage = 1;
    },
    paging(page) {
      this.currentPage = page;
      this.setConditions(this.currentPage);
      this.querySendCoupons(this.currentPage);
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.setConditions(this.currentPage);
      this.querySendCoupons(this.currentPage);
    },
    copy(couponSendId) {
      this.$router.push({
        name: "AddCoupons",
        query: { type: "copy", couponSendId },
      });
      this.setConditions(this.currentPage);
    },
    edit(couponSendId) {
      this.$router.push({
        name: "AddCoupons",
        query: { type: "edit", couponSendId },
      });
      this.setConditions(this.currentPage);
    },
    invalidate(v) {
      this.$confirm(
        `
        <div class="message">
          <div>确认将<strong style="color: #f56c6c">${v.name}</strong>作废？</div>
          <div>(注：作废后优惠券将停止发放，请慎重操作)</div>
        </div>`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          this.$store
            .dispatch("invalidateCoupon", {
              couponSendId: v.couponSendId,
            })
            .then((res) => {
              if (res.code === 0) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
                this.$store.dispatch("querySendCoupons", {
                  status: this.activeTab === 4 ? "" : this.activeTab,
                  sendWayType: this.sendWayType,
                  type: this.sendTarget,
                  event: this.event,
                  keywords: this.keywords,
                  pageSize: this.pageSize,
                  pageNo: this.currentPage,
                  isPlus: this.isPlus,
                });
              }
            });
        })
        .catch(() => {});
    },
    publish(couponSendId) {
      this.$store.dispatch("publishCoupon", {
        couponSendId,
      });
      this.setConditions(1);
    },
    getSendTime(sendId) {
      console.log("111", sendId);
      this.$store
        .dispatch("getSendValidTimes", {
          couponSendId: sendId,
        })
        .then((res) => {
          console.log(res);
          this.sendValidTimes = res.result.records;
          this.timeDialogVisible = true;
        });
    },
    querySendCoupons(currentPage) {
      this.$store.dispatch("querySendCoupons", {
        status: this.status,
        sendWayType: this.sendWayType,
        type: this.sendTarget,
        event: this.event,
        name: this.name,
        pageNo: currentPage,
        pageSize: this.pageSize,
        isPlus: this.isPlus,
        keywords: this.keywords,
        sortColumn: this.sortColumn,
        sortType: this.sortType,
      });
    },
    setParamsCookie() {
      let searchCondition = {
        status: this.status,
        sendWayType: this.sendWayType,
        sendTarget: this.sendTarget,
        event: this.event,
        name: this.name,
        isPlus: this.isPlus,
        keywords: this.keywords,
      };
      setCookie({
        key: "sendParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
        }),
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "sendParams", type: "session" });
      if (prams) {
        this.status = prams.status;
        this.sendWayType = prams.sendWayType;
        this.sendTarget = prams.sendTarget;
        this.event = prams.event;
        this.name = prams.name;
        this.isPlus = prams.isPlus;
        this.keywords = prams.keywords;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    setConditions(currentPage) {
      const conditions = {
        activeTab: this.activeTab,
        status: this.status,
        sendWayType: this.sendWayType,
        type: this.sendTarget,
        event: this.event,
        keywords: this.keywords,
        currentPage,
        sendTarget: this.sendTarget,
        isPlus: this.isPlus,
      };

      setCookie({ type: "session", key: "sendConditions", data: conditions });
    },
    showCdkey(id) {
      this.showCdkModal = true;
      this.$store.dispatch("getCdkey", {
        id,
      });
    },
    sortChange(sort) {
      console.log("sort:", sort);
      this.sortColumn = sort.prop;
      if (sort.order === "descending") {
        this.sortType = "desc";
      } else if (sort.order === "ascending") {
        this.sortType = "asc";
      } else {
        this.sortType = "";
      }
      this.search();
    },
  },
};
</script>
<style lang="scss" scoped>
.btn {
  cursor: pointer;
  font-size: 0.875rem;
  color: #999;
  padding: 8px 20px;
  transition: background 0.1s linear;
}

.btn.active {
  background: #e50065;
  color: #fff;
  border-radius: 5px;
}

.btn.active:hover {
  background: #e50065;
  border-color: #e50065;
}
.table {
  padding: 10px 0;
}
.qrcode-wrapper {
  text-align: center;
  img {
    width: 200px;
    height: 200px;
  }
}
.coupon-name {
  color: #4680ff;
}
.btn-wrapper {
  margin-bottom: 10px;
  text-align: right;
}
.ml0 {
  margin-left: 0;
}
</style>
